import React from 'react';
import PropTypes from 'prop-types';

export default class PDFPageEditorCanvas extends React.Component {

  componentDidMount() {
    const { page, width, height } = this.props;
    if (page.blank) {
      return null;
    }
    const pageViewport = page.getViewport(1);
    const scale = Math.min(width / pageViewport.width, height / pageViewport.height);

    return page.render({ canvasContext: this.canvas.getContext('2d'), viewport: page.getViewport(scale) }).promise.then(() => this.canvas);
  }

  render() {
    const { width, height } = this.props;

    return (
      <canvas height={height} width={width} ref={(el) => { this.canvas = el; }} />
    );
  }
}

PDFPageEditorCanvas.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  page: PropTypes.shape({
    getViewport: PropTypes.func.isRequired,
    render: PropTypes.func.isRequired,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src-react/PDFPageCanvas/index.jsx